import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { Transitioner } from '#components/TransitionProvider'

import * as mobx from 'mobx'
import PT from 'prop-types'

import type { ViewState } from '../Root/viewModel'

import { ATTRIBUTE_AFFECTEDCAR } from '../../utils/constants'
import i18n from '../../utils/i18n'

export type Props = {
  state: ViewState
}

type CarDataSourceItem = {
  primaryText: string
  value: string
}

export type ViewModel = {
  data: {
    affectedCar?: string | null
  }
  availableCars: Array<[string, string]>
  carDataSource: Array<CarDataSourceItem>
  errorText?: string | null

  handleNext: () => void
  handleBack: () => void
  handleFormChange: (Object) => void
  handleAutocompleteSelect: (CarDataSourceItem) => void
  handleAutocompleteChange: (SyntheticInputEvent) => void
}

type Context = {
  transitioner: Transitioner
}

const mkViewModel = (
  params: Params,
  { state }: Props,
  { transitioner }: Context,
): ViewModel => {
  const attrs = transitioner.getAttributes()
  const formatCar = (car) => `${car.brand} ${car.model} (${car.plate})`
  const vm = mobx.observable({
    data:
      attrs && attrs.cars && attrs.cars.length === 1
        ? { affectedCar: formatCar(attrs.cars[0]) }
        : null,
    availableCars:
      (attrs &&
        attrs.cars &&
        attrs.cars.length &&
        attrs.cars.map((car) => [formatCar(car), formatCar(car)])) ||
      [],
    get carDataSource() {
      const response = vm.availableCars.map(([carString, carValue]) => ({
        primaryText: carString,
        value: carValue,
      }))
      return response
    },
    errorText: null,
    handleNext: mobx.action(() => {
      if (!vm.data.affectedCar && vm.availableCars.length > 1) {
        vm.errorText = i18n.translateWithoutTestId('global.required')
      } else {
        state.customAttributes.set(ATTRIBUTE_AFFECTEDCAR, vm.data.affectedCar)
        const nextNode = state.currentNode && state.currentNode.nextNode
        if (nextNode) transitioner.goForward(nextNode.id)
      }
    }),
    handleBack: mobx.action(() => {
      state.customAttributes.delete(ATTRIBUTE_AFFECTEDCAR)
    }),
    handleFormChange: mobx.action((values) => {
      // @ts-expect-error@2339
      const { affectedCar } = values
      vm.data = { affectedCar }
    }),
    handleAutocompleteSelect: mobx.action((selection) => {
      // @ts-expect-error@2339
      vm.data = { affectedCar: selection && selection.value }
    }),
    handleAutocompleteChange: mobx.action((event) => {
      // @ts-expect-error@2339
      vm.data = { affectedCar: event && event.target && event.target.value }
    }),
  })
  // @ts-expect-error@2322
  return vm
}

mkViewModel.contextTypes = {
  transitioner: PT.object.isRequired,
}

export default mkViewModel
